import { render } from "./LandingImage.vue?vue&type=template&id=48c15c9f&scoped=true"
import script from "./LandingImage.vue?vue&type=script&lang=js"
export * from "./LandingImage.vue?vue&type=script&lang=js"

import "./LandingImage.vue?vue&type=style&index=0&id=48c15c9f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c15c9f"]])

export default __exports__